import { PrimaryButton } from '@axafr-btc-ds/buttons';
import styles from './DatadomeHandler.module.css';
import { useState } from 'react';
import { DATA_DOME_RESPONSE_PASSED_EVENT } from '@axa-fr-axion/http';
import { Typography } from '@axafr-btc-ds/typography';
import { ColorHex } from '@axafr-btc-ds/colors';

export const DataDomeHandler = () => {
    const [ value, setValue ] = useState('');

    const handleClick = () => {
        if (value === '2') {
            window.dispatchEvent(new Event(DATA_DOME_RESPONSE_PASSED_EVENT));
        }
    };

    return (
        <div className={ styles.container }>
            <Typography variant='headline2'>Welcome to Axion Datadome</Typography>
            <div>
                <span> 1 <strong>+</strong> 1 = </span>
                <input value={ value } onChange={ event => setValue(event.target.value) } />
            </div>
            <PrimaryButton onClick={ handleClick }>Valider</PrimaryButton>
            { !!value && value !== '2' && <Typography variant='body1' color={ ColorHex.axared }>Ce n'est pas le bon result</Typography> }
        </div>
    );
};
